import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';

const AlertFaxDownloadModal = ({ isOpen, onConfirm, onCancel, title, body }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <div>{body}</div>
        <div style={{ color: '#3b5aa9' }}>{/* Warning: This function cannot be undone! */}</div>
      </ModalBody>
      <ModalFooter className="modalFooterEpiDelete">
        <Button color="primary" onClick={onConfirm}>
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AlertFaxDownloadModal;
